import _ from "lodash";
import {Grid, Typography} from "@mui/material";
import {KeyValuePair} from "../base/KeyValuePair";
import {User} from "../../types/domain/user";
import {DEFAULT_USER_PREFERENCES} from "../../utils/userUtils";
import {useTranslation} from "react-i18next";

export interface Props {
    user: User;
}

export const UserPreferencesCard: React.FC<Props> = ({user}) => {
    const {t} = useTranslation();
    const preferences = {
        ...DEFAULT_USER_PREFERENCES,
        ...user.preferences,
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={6}>
                <KeyValuePair header={t("users.preferences.language")}>
                    <Typography>{_.capitalize(preferences.language)}</Typography>
                </KeyValuePair>
            </Grid>
            <Grid item xs={6}>
                <KeyValuePair header={t("users.preferences.unit")}>
                    <Typography>{_.capitalize(preferences.measureSystem)}</Typography>
                </KeyValuePair>
            </Grid>
            <Grid item xs={6}>
                <KeyValuePair header={t("users.preferences.onscreen_help")}>
                    <Typography>
                        {preferences.enabledUiHelp ? t("users.preferences.yes") : t("users.preferences.no")}
                    </Typography>
                </KeyValuePair>
            </Grid>
            <Grid item xs={6}>
                <KeyValuePair header={t("users.preferences.advanced")}>
                    <Typography>
                        {preferences.enabledAdvancedFeatures ? t("users.preferences.yes") : t("users.preferences.no")}
                    </Typography>
                </KeyValuePair>
            </Grid>
            <Grid item xs={6}>
                <KeyValuePair header={t("users.preferences.field_alert")}>
                    <Typography>
                        {preferences.enabledFieldAlerts ? t("users.preferences.yes") : t("users.preferences.no")}
                    </Typography>
                </KeyValuePair>
            </Grid>
            <Grid item xs={6}>
                <KeyValuePair header={t("users.preferences.marketing")}>
                    <Typography>
                        {preferences.enabledMarketingEmails ? t("users.preferences.yes") : t("users.preferences.no")}
                    </Typography>
                </KeyValuePair>
            </Grid>
        </Grid>
    );
};
